import { post } from '@/utils/request'

export function saveContact(params) {
  return post(`https://gw.work.xxkucun.com/xkc-crm/messageboard/insert`, params)
}
